import { ElMessage, ElLoading, ElLoadingService } from 'element-plus';

// import { defineComponent, ref, onMounted } from 'vue';
// export default defineComponent({
//     setup() {
//         let fullscreenLoading: any
//         const openLoading = () => {
//             fullscreenLoading = ElLoading.service({
//                 lock: true,
//                 text: 'Loading',
//                 background: 'rgba(0, 0, 0, 0.7)',
//             })
//         }
//         return {
//             fullscreenLoading,
//             openLoading
//         }
//     }
// })
export let fullscreenLoading:any
export function openLoading(): void {
    fullscreenLoading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    })
}